<template>
    <div class="px-1 text-gray-300">|</div>
</template>
